import $axios from '../helpers/axios-instance'

export const dataTableInterceptor = function (sSource, aoData, fnCallback, oSettings, url, offset) {
    try {

        let data = {};
        data['type'] = aoData['type'];
        for (let i in aoData) {
            let item = aoData[i];
            if (typeof item.value === 'object' && item.value !== undefined && item.value !== null) {
                if (item.name === 'search') {
                    let search = item.value;
                    data[`search[value]`] = search.value || '';
                    data[`search[regex]`] = search.regex || false;
                    break;
                }
                for (let vi in item.value) {
                    let vitem = item.value[vi];
                    if (item.name === 'columns') {
                        data[`columns[${vi}][data]`] = vitem.data;
                        data[`columns[${vi}][name]`] = vitem.name || '';
                        data[`columns[${vi}][searchable]`] = vitem.searchable || false;
                        data[`columns[${vi}][orderable]`] = vitem.orderable || false;
                        if (typeof vitem.search === 'object') {
                            data[`columns[${vi}][search][value]`] = vitem.search.value || '';
                            data[`columns[${vi}][search][regex]`] = vitem.search.regex || '';
                        }
                    } else if (item.name === 'order') {
                        data[`order[${vi}][column]`] = vitem.column || 0;
                        data[`order[${vi}][dir]`] = vitem.dir || 'asc';
                    } else {
                        data[item.name] = item.value;
                    }
                }
            } else {
                data[item.name] = item.value;
            }
        }

        data['offset'] = offset

        oSettings.jqXHR = $axios.get(url, {
            params: data
        }).then(response => {
            //send server response to oSettings callback
            oSettings.serverResponse = response.data;

            fnCallback(response.data || {})
        }).catch((error) => {
            console.log(error)
        });
    } catch (e) {
        const response = error.response
        console.log(response.data.errors)
        console.log('dataTableInterceptor', e)
    }
    return oSettings;
};